var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolvoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 338.8 338.7",
    style: {
      enableBackground: "new 0 0 338.8 338.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#EAEAEA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 338.8,
    height: 338.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Volvo_Iron_Mark"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.4,177.9h27.4v-9.1h-3c0,3.5-2.6,6.1-6.5,6.1h-4.2v-13.7h4.6v-3h-18.3v3h4.6l0,13.7h-4.6L158.4,177.9 L158.4,177.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "199,177.9 209.6,177.9 218.7,161.2 223.2,161.2 223.2,158.2 209.6,158.2 209.6,161.2 213.5,161.2  206.9,173.4 200.2,161.2 205,161.2 205,158.2 185.2,158.2 185.2,161.2 189.8,161.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "103.8,158.2 84,158.2 84,161.2 88.5,161.2 97.7,177.9 108.4,177.9 117.4,161.2 122,161.2 122,158.2  108.3,158.2 108.3,161.2 112.3,161.2 105.7,173.4 99,161.2 103.8,161.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6,168.1c0,5.8,4.7,10.4,14.1,10.4c9.4,0,14-4.6,14-10.4c0-5.7-4.9-10.3-14.1-10.3 C129.5,157.8,124.6,162.3,124.6,168.1z M143.6,168.1c-0.1,3.6-1.6,7.3-5,7.3c-3.4-0.1-4.8-3.8-4.8-7.4c0.1-3.8,1.9-7.1,5-7.1 C142,160.9,143.6,164.3,143.6,168.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.8,168.1c0,5.8,4.7,10.4,14.1,10.4s14-4.6,14-10.4c0-5.7-4.9-10.3-14.1-10.3 C230.7,157.8,225.8,162.3,225.8,168.1z M240,160.9c3.1,0.1,4.8,3.4,4.7,7.2c-0.1,3.6-1.6,7.3-5,7.3c-3.4-0.1-4.8-3.8-4.8-7.4 C235.1,164.1,236.9,160.8,240,160.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.3,105.2l-11.5,11.5c9.8,15.2,15.5,33.3,15.5,52.7c0,53.6-43.4,97-97,97s-97-43.4-97-97s43.4-97,97-97 c19.5,0,37.6,5.7,52.8,15.6l11.5-11.5c-18.2-12.7-40.4-20.1-64.3-20.1C107,56.5,56.5,107,56.5,169.4S107,282.3,169.4,282.3 s112.9-50.6,112.9-112.9C282.3,145.5,274.9,123.4,262.3,105.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.2,60.9v3.2c6.9,3.7,13.3,8.1,19.3,13l-16.1,16.1c6.1,4.8,11.6,10.2,16.3,16.3l16.1-16.1 c4.9,6,9.3,12.4,13,19.2h3.1V60.9H226.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolvoLogo);
export default __webpack_public_path__ + "static/media/Volvo_Logo.77b3da771f319dca7ae4eda8db93eb95.svg";
export { ForwardRef as ReactComponent };